<template>
  <!-- 手动审核退款 -->
  <div class="manualRefund" style="min-width:1100px">
    <!-- 顶部搜索区块 -->
    <div class="content">
      <h4>
        手动审核退款
        <p style="background-color: #fafafa; padding: 0 12px; height: 28px;border-radius: 14px">
          <span style="position: relative; top: -13px; color: #333">当前有</span
          ><span style="position: relative; top: -13px; color: #fe4d45;margin:0 4px">0</span>
          <span <span style="position: relative; top: -13px">个退款单</span>
          <span style="position: relative; top: -13px; color: #7f85e9;margin-left:4px">待审核</span>
        </p>
      </h4>
      <!-- 头部导航栏 -->
      <div class="tabList">
        <span :class="{ active: tabActiveIndex == 1 }" @click="tabActiveIndex = 1">手动审核退款</span>
        <span :class="{ active: tabActiveIndex == 2 }" @click="tabActiveIndex = 2">短信记录</span>
        <i></i>
      </div>
      <div class="manualForm">
        <input-form
          :inputData="inputData"
          @toParentVal="evaluateSearch"
          v-show="tabActiveIndex == 1"
          ref="evaluateForm"
          :btnPosition1="true"
        ></input-form>
        <input-form
          :inputData="smsInputData"
          @toParentVal="getSmsRecordList"
          v-show="tabActiveIndex == 2"
          ref="recordForm"
          :btnPosition1="true"
        ></input-form>
      </div>
    </div>
    <!-- 评价预警表格 -->
    <div class="tabel-container" v-show="tabActiveIndex == 1">
      <div class="handleBtns">
        <button class="b1" v-zoom="{ from: pageName, name: '批量审核' }" @click="batchExamine">批量审核</button>
        <button class="b2" v-zoom="{ from: pageName, name: '批量发送短信' }" @click="batchSendSms">批量发送短信</button>
        <button class="b3" v-zoom="{ from: pageName, name: '按查询结果发送短信' }" @click="byQuerySendSms">按查询结果发送短信</button>
      </div>
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableData"
        tooltip-effect="light"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%; margin-top: 18px"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="退款订单号" prop="refundApplyId" width="120">
          <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
        </el-table-column>
        <el-table-column prop="desensitizePin" label="买家账号" width="160"></el-table-column>
        <el-table-column prop="orderId" label="订单号" width="140"></el-table-column>
        <el-table-column prop="orderState" label="出库状态">
          <template slot-scope="scope">
            {{ scope.row.orderState == 1 ? "已出库" : "未出库" }}
          </template>
        </el-table-column>
        <el-table-column prop="orderPayment" label="实付金额"></el-table-column>
        <el-table-column prop="applyRefundSum" label="退款金额"></el-table-column>
        <el-table-column prop="p6" label="购买次数"></el-table-column>
        <el-table-column prop="refundStatus" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.refundStatus == 0">未审核</span>
            <span v-if="scope.row.refundStatus == 1">审核通过</span>
            <span v-if="scope.row.refundStatus == 2">审核不通过</span>
            <span v-if="scope.row.refundStatus == 3">京东财务审核通过</span>
            <span v-if="scope.row.refundStatus == 4">京东财务审核不通过</span>
            <span v-if="scope.row.refundStatus == 5">人工审核通过</span>
            <span v-if="scope.row.refundStatus == 6">拦截并退款</span>
            <span v-if="scope.row.refundStatus == 7">青龙拦截成功</span>
            <span v-if="scope.row.refundStatus == 8">青龙拦截失败</span>
            <span v-if="scope.row.refundStatus == 9">强制关单并退款</span>
            <span v-if="scope.row.refundStatus == 10">物流待跟进</span>
          </template>
        </el-table-column>
        <el-table-column prop="checkUserName" label="审核人"></el-table-column>
        <el-table-column prop="checkTime" label="审核时间"></el-table-column>
        <el-table-column prop="handle" label="操作" width="150px">
          <template slot-scope="scope">
            <div class="handle">
              <!-- :class="scope.row.refundStatus == 0 ? 'red' : 'grayssss'" -->
              <span
                class="operation"
                v-zoom="{ from: pageName, name: '退款审核' }"
                v-if="scope.row.refundStatus == 1 || scope.row.refundStatus == 0"
                @click="handleExamine(scope.row)"
                >退款单审核</span
              >
              <span style="color: #ddd" v-if="scope.row.refundStatus != 1 && scope.row.refundStatus != 0">已审核</span>
              <span class="operation" v-zoom="{ from: pageName, name: '查看' }" style="margin-left: 5px" v-else @click="viewDetails(scope.row)"
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :page-sizes="[10, 30, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 短信记录表格 -->
    <div class="tabel-container" v-show="tabActiveIndex == 2">
      <el-table
        :data="smsTableData"
        v-loading="recordLoading"
        tooltip-effect="light"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%; margin-top: 18px"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column label="买家昵称" prop="desensitizePin">
          <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
        </el-table-column>
        <el-table-column prop="mobile" label="手机号码">
          <template slot-scope="scope">{{ (scope.row.mobile || "--") | mobileEllipsis }}</template>
        </el-table-column>
        <el-table-column prop="content" label="短信内容"></el-table-column>
        <el-table-column prop="status" label="发送状态">
          <template slot-scope="scope">
            <span style="display: block; margin: 10px 0">
              {{
                scope.row.status == 0
                  ? "未发送"
                  : scope.row.status == 1
                  ? "已发送"
                  : scope.row.status == 2
                  ? "黑名单过滤"
                  : scope.row.status == 3
                  ? "过滤重复发送"
                  : scope.row.status == 4
                  ? "10分钟内容重复"
                  : scope.row.status == 6
                  ? "给过中差评过滤"
                  : scope.row.status == 7
                  ? "退过款过滤"
                  : "无效号码"
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="发送时间"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleRecordSizeChange"
        @current-change="handleRecordCurrentChange"
        background
        :page-sizes="[10, 30, 50, 100]"
        :page-size="recordSize"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="recordTotal"
      >
      </el-pagination>
    </div>

    <!-- 批量审核弹窗 -->
    <myPopup :title="curExamineData ? '退款单审核' : '批量审核退款'" width="590" :zIndex="'3333'" :flag="examineVisible" @close="handleExamineClose">
      <div class="examinePopup">
        <p class="tips" v-if="!curExamineData">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 0px 4px 0 3px;
            "
          />
          当前勾选了{{ checkList.all }}条未审核订单，其中有{{ checkList.not }}条尚未出库，有{{ checkList.read }}条已出库
        </p>
        <p class="tips" v-if="curExamineData">
          <img
            src="@/assets/images/new_icon_waring_yellow.png"
            style="
              display: inline-block;
              float: left;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 0px 4px 0 3px;
            "
          />
          截止至{{ auditList.checkInvalidateTime }}任未处理，系统将会自动审核通过！
        </p>
        <div class="details" v-if="curExamineData">
          <span>订单号:{{ auditList.orderId }} </span>
          <span
            >订单状态:
            <span v-if="curExamineData.orderState == 1">已出库</span>
            <span v-if="curExamineData.orderState == 2">未出库</span>
          </span>
          <span>退款订单号:{{ auditList.refundApplyId }}</span>
          <span>退款金额:￥{{ auditList.applyRefundSum }}</span>
          <span>买家账号:{{ auditList.desensitizePin }}</span>
          <span>申请日期:{{ auditList.applyTime }}</span>
          <span>订单来源:{{ auditList.orderSource }}</span>

          <span
            >支付方式:
            <span v-if="auditList.payType == 1">货到付款</span>
            <span v-if="auditList.payType == 2">邮局汇款</span>
            <span v-if="auditList.payType == 3">自提</span>
            <span v-if="auditList.payType == 4">在线支付</span>
            <span v-if="auditList.payType == 5">公司转账</span>
            <span v-if="auditList.payType == 6">银行转账</span>
          </span>
        </div>
        <el-form :model="drawerForm" status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="实际出库状态:">
            <el-select v-model="drawerForm.outWareStatus" placeholder="请选择">
              <el-option label="已出库" :value="1">已出库</el-option>
              <el-option label="未出库" :value="2">未出库</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核人:">
            <el-input v-model="drawerForm.checkUserName"></el-input>
          </el-form-item>
          <el-form-item label="审核备注:">
            <el-input type="textarea" maxlength="50" show-word-limit v-model="drawerForm.remark" rows="4"></el-input>
            <p class="tip">
              <img
                src="@/assets/images/new_icon_waring_yellow.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 0px 4px 0 3px;
                "
              />
              除强制关单外的其它审核结果下必需填写审核备注
            </p>
          </el-form-item>
          <el-form-item label="审核结果:">
            <el-radio-group v-model="drawerForm.replyStatus">
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核不通过</el-radio>
              <el-radio :label="6">通过并京东拦截</el-radio>
              <el-radio :label="9">强制关单</el-radio>
              <el-radio :label="10">物流待跟进</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="footBtn">
          <button class="cancel" @click="handleExamineClose">取消</button>
          <button class="confirm" @click="examineConfirm">确认</button>
        </div>
      </div>
    </myPopup>
    <!-- 订单查看 -->
    <myPopup title="退款单查看" width="590" :flag="refundVisible" @close="handleRefundClose">
      <div class="refundDetails">
        <span>订单号:{{ curRefundData.orderId }}</span>
        <span>订单状态:{{ curRefundData.orderState }}</span>
        <span>退款订单号:{{ curRefundData.refundApplyId }}</span>
        <span>退款金额:￥{{ curRefundData.applyRefundSum }}</span>
        <span>买家账号:{{ curRefundData.desensitizePin }}</span>
        <span>申请日期:{{ curRefundData.checkTime }}</span>
        <span>订单来源:{{ curRefundData.orderSource }}</span>
        <span v-if="curRefundData.payType == 1">支付方式:货到付款</span>
        <span v-if="curRefundData.payType == 2">支付方式:邮局汇款</span>
        <span v-if="curRefundData.payType == 3">支付方式:自提</span>
        <span v-if="curRefundData.payType == 4">支付方式:在线支付</span>
        <span v-if="curRefundData.payType == 5">支付方式:公司转账</span>
        <span v-if="curRefundData.payType == 6">支付方式:银行转账</span>
        <span>实际出库状态:{{ curRefundData.orderState == 1 ? "已出库" : "未出库" }}</span>
        <span>审核人: {{ curRefundData.checkUserName }}</span>
      </div>
    </myPopup>
    <!-- 批量发送短信 -->
    <sendSms
      :drawer="drawer"
      @close="drawerClose"
      :checkData="multipleSelection"
      :sendType="sendType"
      :count="checkCount"
      :searchForm="searchFormData"
      :dataFrom="9"
      taskName="手动审核退款"
    >
    </sendSms>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import sendSms from "./components/sendSms";
import myPopup from "@/components/myPopup";
import { getManualAuditRefund, auditBatch, count, getOrderDetail, getSmsRecord } from "@/api/serviceCenter/manualRefund";

export default {
  components: {
    inputForm,
    sendSms,
    myPopup,
  },
  data() {
    return {
      pageName: "售后中心-手动审核退款",
      auditList: [],
      tabActiveIndex: 1,
      inputData: [
        // 评价预警表单项
        {
          name: "退款单号:",
          val: "refundApplyId",
          placeholder: "请输入退款单号",
        },
        {
          name: "买家账号:",
          val: "buyerId",
          placeholder: "请输入买家账号",
        },
        {
          name: "订单号:",
          val: "orderId",
          placeholder: "请输入订单号",
        },
        {
          name: "申请时间:",
          myDate: true,
          val: ["applyTimeStart", "applyTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "出库状态:",
          val: "orderState",
          selectArr: [
            { label: "已出库", id: 1 },
            { label: "未出库", id: 2 },
          ],
        },
        {
          name: "审核状态:",
          val: "refundStatus",
          default: "0",
          selectArr: [
            // { label: "全部", id: "" },
            { label: "未审核", id: "0" },
            { label: "审核通过", id: "1" },
            { label: "审核不通过", id: "2" },
            { label: "京东财务审核通过", id: "3" },
            { label: "京东财务审核不通过", id: "4" },
            { label: "人工审核通过", id: "5" },
            { label: "拦截并退款", id: "6" },
            { label: "青龙拦截成功", id: "7" },
            { label: "青龙拦截失败", id: "8" },
            { label: "强制关单并退款", id: "9" },
            { label: "物流待跟进", id: "10" },
          ],
        },
        {
          name: "审核时间:",
          myDate: true,
          val: ["checkTimeStart", "checkTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
      ],
      smsInputData: [
        {
          name: "手机号:",
          val: "mobile",
          placeholder: "请输入手机号",
        },
        {
          name: "发送时间:",
          myDate: true,
          val: ["sendStartTime", "sendEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "发送状态:",
          val: "status",
          selectArr: [
            { label: "未发送", id: 0 },
            { label: "已发送", id: 1 },
            { label: "黑名单过滤", id: 2 },
            { label: "过滤重复发送", id: 3 },
            { label: "10分钟内容重复", id: 4 },
            { label: "无效号码", id: 5 },
          ],
        },
      ],
      // 短信发送类型  1 按条件查询 2 勾选
      sendType: 1,
      // 手动审核退款表格数据
      tableData: [],
      // 存储按查询结果发送短信需要的查询参数
      searchFormData: {},
      tableLoading: false,
      total: 0,
      current: 1,
      size: 10,
      // 短信记录表格数据
      smsTableData: [],
      recordLoading: false,
      recordTotal: 0,
      recordCurrent: 1,
      recordSize: 10,
      // 存储被勾选的列表
      multipleSelection: [],
      // 存储复选框选中人数
      checkCount: 0,
      // 存储单挑审核数据
      curExamineData: null,
      // 批量审核弹窗控制
      examineVisible: false,
      // 批量发送短信状态控制
      drawer: false,
      // 审核弹窗表单
      drawerForm: {
        outWareStatus: 1,
        checkUserName: "",
        remark: "",
        replyStatus: 1,
      },
      // 订单查看窗口控制
      refundVisible: false,
      // 存储当前查看订单数据
      curRefundData: {},
    };
  },
  computed: {
    checkList() {
      console.log(this.multipleSelection);
      let read = this.multipleSelection.filter((item) => item.orderState == 1);
      let not = this.multipleSelection.filter((item) => item.orderState != 1);

      return {
        all: this.multipleSelection.length,
        not: not.length,
        read: read.length,
      };
    },
  },
  created() {
    // 埋点
    this.buriedPoint(1, '手动审核退款', '售后中心', '退款中心')
  },
  mounted() {
    this.$refs.evaluateForm.submitForm("formSearch");
    this.$refs.recordForm.submitForm("formSearch");
  },
  methods: {
    // 评价预警表格搜索
    evaluateSearch(form, state) {
      console.log(form);
      this.tableLoading = true;
      form.size = this.size;
      form.current = state ? 1 : this.current;
      this.searchFormData = form;
      getManualAuditRefund(form).then((res) => {
        this.tableData = res && res.data.records;
        this.total = res && +res.data.total;
        this.tableLoading = false;
      });
    },
    // 获取短信记录
    getSmsRecordList(form) {
      this.recordLoading = true;
      form.size = this.recordSize;
      form.current = this.recordCurrent;
      getSmsRecord(form).then((res) => {
        this.smsTableData = res && res.data.records;
        this.recordTotal = res && +res.data.total;
        this.recordLoading = false;
      });
    },
    // 批量审核
    batchExamine() {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning("请勾选订单");
        return;
      }
      let refundStatus = "";
      let idsArr = [];
      this.multipleSelection.forEach((item) => {
        idsArr.push(item.refundStatus);
        // console.log(item.refundStatus);
        if (item.refundStatus != 0) {
          refundStatus = 1;
        }
      });
      if (refundStatus == 1) {
        this.$message.warning("所选含已审核退款单哦~请重新选择");
        return;
      }
      // console.log(refundStatus);
      if (this.multipleSelection.length == 1) {
        // this.curExamineData = this.multipleSelection[0];
        this.getOrderInfo(this.multipleSelection[0].id);
      }
      this.examineVisible = true;
    },
    // 单挑数据审核
    handleExamine(data) {
      this.curExamineData = data;
      if (data.refundStatusName == "未审核") {
        this.examineVisible = true;
        getOrderDetail(data.id).then((res) => {
          this.auditList = res.data;
        });

        this.color = 1;
      }
    },
    // 表格勾选变化监听
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 审核确认
    examineConfirm() {
      let param = Object.assign(this.drawerForm),
        data = [];
      if (!param.checkUserName) {
        this.$message.warning("请输入审核人！");
        return;
      }
      if (param.replyStatus != "9" && !param.remark) {
        this.$message.warning("请输入审核备注！");
        return;
      }

      if (this.multipleSelection.length > 1) {
        this.multipleSelection.forEach((item) => {
          data.push({
            orderState: item.orderState,
            outWareStatus: item.orderState,
            refundApplyId: item.refundApplyId,
          });
        });
      } else {
        data.push({
          orderState: this.curExamineData.orderState,
          outWareStatus: this.curExamineData.orderState,
          refundApplyId: this.curExamineData.refundApplyId,
        });
      }
      param.data = data;
      auditBatch(param).then((res) => {
        if (res.code == "1") {
          this.$message.success(res.data);
          this.handleExamineClose();
          this.$refs.evaluateForm.submitForm("formSearch");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 根据id查询退款单和订单信息
    getOrderInfo(id) {
      getOrderDetail(id).then((res) => {
        this.curExamineData = res && res.data;
      });
    },
    // 按查询结果发送短信
    byQuerySendSms() {
      if (this.tableData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.checkCount = this.total;
      this.sendType = 1;
      this.drawer = true;
    },
    // 批量发送短信
    batchSendSms() {
      if (this.multipleSelection.length <= 0) {
        this.$message.warning("请勾选订单");
        return;
      }
      if (this.multipleSelection.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.checkCount = this.multipleSelection.length;
      this.sendType = 2;
      this.drawer = true;
    },
    drawerClose() {
      this.drawer = false;
    },
    // 批量审核弹窗隐藏
    handleExamineClose() {
      // 清空表格勾选列表
      this.curExamineData = null;
      // 重置内容
      (this.drawerForm = {
        outWareStatus: 1,
        checkUserName: "",
        remark: "",
        replyStatus: 1,
      }),
        (this.examineVisible = false);
    },
    // 订单查看
    viewDetails(data) {
      this.curRefundData = data;
      this.refundVisible = true;
    },
    // 订单查看隐藏
    handleRefundClose() {
      this.refundVisible = false;
    },
    // 分页变化
    handleSizeChange(val) {
      this.current = 1;
      this.size = val;
      this.$refs.evaluateForm.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.evaluateForm.submitForm("formSearch");
    },
    // 短信记录分页变化
    handleRecordSizeChange(val) {
      this.recordSize = val;
      this.recordCurrent = 1;
      this.$refs.recordForm.submitForm("formSearch");
    },
    handleRecordCurrentChange(val) {
      this.recordCurrent = val;
      this.$refs.recordForm.submitForm("formSearch");
    },
  },
};
</script>

<style scoped lang="scss">
.red {
  color: #fe4d45 !important;
}
.grayssss {
  color: gray !important;
  cursor: not-allowed !important;
}
.manualRefund {
  box-sizing: border-box;
  padding: 10px 20px 45px;
  button {
    box-sizing: border-box;
    padding: 6px 12px;
    border: none;
    outline: none;
    background-color: #fff;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;
    font-size: 14px;
  }
  .content {
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    h4 {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: 54px;
      line-height: 53px;
      border-bottom: 1px solid #f0f0f0;
      padding-left: 28px;
      margin: 0;
      border-bottom: 1px solid #f0f0f0;
      color: #2e3458;
      font-size: 16px;
      font-weight: bold;
      p {
        margin: 0 0 0 12px;
        color: #666;
        font-size: 14px;
        font-weight: 400;
        span {
          &:first-child {
            color: #fe4d45;
          }
          &:last-child {
            color: #7f85e9;
          }
        }
      }
    }
    .tabList {
      display: flex;
      box-sizing: border-box;
      padding: 0 28px;
      height: 36px;
      line-height: 35px;
      margin-top: 20px;
      color: #999;
      font-size: 14px;
      span {
        width: 106px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        border-radius: 2px 2px 0px 0px;
        border: 1px solid #dddddd;
        text-align: center;
      }
      .active {
        position: relative;
        transition: all 0.2s;
        color: #fe4d45;
        border-bottom: none;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          top: 0;
          height: 2px;
          background: #fe4d45;
          border-radius: 6px 6px 0px 0px;
        }
      }
      i {
        flex: 1;
        border-bottom: 1px solid #f6f6f6;
      }
    }
    .manualForm {
      box-sizing: border-box;
      padding: 20px 0;
    }
  }
  .tabel-container {
    box-sizing: border-box;
    padding: 24px 28px 30px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .handleBtns {
      display: flex;
      align-items: center;
      .b1 {
        width: 98px;
        height: 32px;
        color: #ffffff;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
      }
      .b2 {
        padding: 0 12px;
        margin: 0 8px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .b3 {
        padding: 0 12px;
        height: 32px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
    .handle {
      display: flex;
      align-items: center;
      .operation {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
      span {
        padding: 20px 0;
        cursor: pointer;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .examinePopup {
    margin-top: 16px;
    width: 100%;
    .tips {
      display: flex;
      align-items: center;
      margin: 0;
      padding: 12px;
      border-radius: 3px;
      background: #fffaee;
      color: #333;
      i {
        margin-right: 6px;
        color: #fe8f8a;
      }
    }
    .tip {
      display: flex;
      align-items: center;
      background: #fffaee;
      border-radius: 3px;
      margin: 8px 0 0 0;
      color: #333;
      i {
        margin-right: 6px;
        color: #fe8f8a;
      }
    }
    .footBtn {
      text-align: right;
      .cancel {
        width: 98px;
        margin-right: 8px;
        height: 32px;
        color: #999999;
        border-radius: 3px;
        border: 1px solid #cccccc;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
      .confirm {
        width: 98px;
        height: 32px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
    }
    .details {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 26px;
      font-size: 14px;
      color: #333;
      span {
        width: 50%;
        margin-bottom: 16px;
        text-align: left;
      }
    }
    .el-radio-group {
      line-height: 28px;
    }
  }
  .refundDetails {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 26px;
    padding-top: 10px;
    font-size: 14px;
    color: #333;
    span {
      width: 50%;
      margin-bottom: 16px;
      text-align: left;
    }
  }
}
</style>
